import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} NriPool. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
